import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { useCallback, useState } from 'react';
import { createRequestResetPasswordOutbound } from '../../api/outbound/lobbyOutbounds';
import { OpenModalContainer } from '../../components/openModalContainer';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { darkTheme } from '../../styles/materialTheme';
export const LoginRecoveryModal = ({ onClose }) => {
    const [usernameOrEmail, setUsernameOrEmail] = useState('');
    const socketSend = useSocketSend();
    const onClickSend = useCallback(() => {
        if (usernameOrEmail) {
            socketSend(createRequestResetPasswordOutbound(usernameOrEmail));
            onClose();
        }
    }, [onClose, usernameOrEmail, socketSend]);
    const onKeyDown = useCallback((event) => {
        if (event.key === 'Enter') {
            onClickSend();
        }
    }, [onClickSend]);
    const onChangeUsernameOrEmail = (event) => {
        setUsernameOrEmail(event.target.value);
    };
    return (_jsx(StyledEngineProvider, { injectFirst: true, children: _jsx(ThemeProvider, { theme: darkTheme, children: _jsxs(OpenModalContainer, { title: 'Login Recovery', onClose: onClose, children: [_jsx(DialogContent, { children: _jsx(DialogContentText, { children: "Enter the username or email of the account you need to recover. If a matching account exists, a recovery link will be emailed to you." }) }), _jsxs(DialogActions, { children: [_jsx(TextField, { type: 'text', variant: 'filled', fullWidth: true, label: 'Username or Email', value: usernameOrEmail, onChange: onChangeUsernameOrEmail, onKeyDown: onKeyDown }), _jsx(Button, { variant: 'contained', onClick: onClickSend, children: "Send" })] })] }) }) }));
};
